import styled from 'styled-components';

import { H2, LabelRegular, LabelBold } from '@comeon/ui';

import { breakpointDesktop, DESKTOP_MODAL_HEIGHT } from './game-info.styles';

export const SecondarySection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	justify-content: flex-start;
	background-color: var(--game-info-section-background-color);

	&::-webkit-scrollbar {
		display: none;
	}

	width: 100vw;
	padding: 12px 12px 0 12px;

	${breakpointDesktop} {
		width: 345px;
		padding: 12px;
		height: ${DESKTOP_MODAL_HEIGHT}px;
		overflow-y: auto;
	}
`;

export const InfoCard = styled.div`
	margin-bottom: 12px;
	border-radius: 12px;
	overflow: hidden;
`;

// Jackpot
export const JackpotContainer = styled(InfoCard)`
	min-height: 96px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: var(--game-info-card-color);
`;

export const JackpotAmount = styled(H2)`
	color: var(--game-info-jackpot-amount-text-color);
`;

export const JackpotWord = styled(LabelRegular)`
	color: rgba(var(--font-supportive), 1);
`;

// Info rows
export const InfoContainer = styled(InfoCard)`
	background-color: var(--game-info-background-color);

	&:empty {
		margin-bottom: 0;
	}
`;

export const InfoRow = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	height: 44px;
	padding: 0 12px;
	background-color: var(--game-info-card-color);

	&:not(:last-child)::before {
		content: '';
		position: absolute;
		left: 12px;
		bottom: 0;
		height: 1px;
		z-index: 1;
		width: calc(100% - 24px);
		border-bottom: 1px solid var(--game-info-separator-color);
	}

	&::after {
		content: '';
		display: block;
		position: absolute;
		bottom: 0;
		left: 12px;
		right: 12px;
		width: calc(100% - 24px);
		height: 1px;
		background-color: var(--game-info-background-color);
	}
`;

export const RowTitle = styled(LabelRegular)`
	color: rgba(var(--font-supportive), 1);
`;

export const VolatilityValueWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	justify-content: center;
	padding-bottom: 10px;
	gap: 4px;
`;

export const RowValue = styled(LabelBold)`
	color: var(--game-info-row-value-text-color);
`;
